module.exports = __webpack_public_path__ + "static/img/qzsp.f414735.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/qzsp.png
// module id = 6eNC
// module chunks = 0